<template>
    <GetStartedLayout
        :errors="errors"
        :needHelp="false"
        ref="layout"
        :breadcrumbs="['Home', 'Refer A Friend']"
    >
        <v-container>
            <v-row>
                <v-col cols="12" sm="6">
                    <FormTitle dark class="pa-4 pb-0"
                        >Thank you!<template #subtitle>
                            <div class="text-lg">
                                <u>Now here’s the special gift</u>: If you could
                                give someone a month of lessons at Musicologie
                                without it costing you anything, would you?
                            </div>
                            <br />
                            <div class="text-lg">
                                Here’s your chance! If you know someone who
                                would benefit from music lessons, we’d love to
                                give them
                                <u>a free month of lessons</u>. Just enter their
                                info below and we’ll hook them up!
                            </div>
                            <br />
                            <div class="text-lg" v-if="false">
                                These lessons for your friend come with no
                                strings attached. We just want to say thanks to
                                you, and to share Musicologie with someone who
                                might benefit.
                            </div>
                        </template>
                    </FormTitle>
                </v-col>
                <v-col cols="12" sm="6" class="pa-0"
                    ><StudentSurveyReferral
                        :errors="errors"
                        :surveyID="surveyID"
                        @success="$refs.layout.showMessage = true" /></v-col
            ></v-row>
        </v-container>
    </GetStartedLayout>
</template>

<script>
import GetStartedLayout from "../../Layouts/GetStartedLayout.vue";
import { Link } from "@inertiajs/vue2";
import StudentSurveyReferral from "../../Components/StudentSurvey/StudentSurveyReferral.vue";
import FormTitle from "../../Components/Form/FormTitle.vue";

export default {
    components: {
        GetStartedLayout,
        Link,
        StudentSurveyReferral,
        FormTitle,
    },
    props: {
        errors: {},
        user: {
            type: Object,
            default: () => {},
        },
        surveyID: {
            type: Number,
            default: null,
        },
    },
};
</script>

<style scoped></style>
